<template>
  <GeneralLayout>
    <template v-slot:header> <GeneralHeader :title="''" /></template>
    <template v-if="doneTutorial" v-slot:main> <RiddleContainer /></template>
    <template v-else v-slot:main> <RiddleTutorialContainer /></template>
  </GeneralLayout>
</template>

<script lang="ts">
import GeneralHeader from '../../components/base/GeneralHeader.vue';
import GeneralLayout from '../../components/layout/GeneralLayout.vue';
import Vue from 'vue';
import Component from 'vue-class-component';
import RiddleTutorialContainer from '../../components/tests/riddle/RiddleTutorialContainer.vue';
import RiddleContainer from '../../components/tests/riddle/RiddleContainer.vue';
import RiddleModule from '@/store/modules/RiddleModule';
import { getModule } from 'vuex-module-decorators';
import store from '../../store';
import SnackbarModule from '@/store/modules/SnackbarModule';
import UserModule from '@/store/modules/UserModule';

@Component({
  components: {
    RiddleContainer,
    RiddleTutorialContainer,
    GeneralLayout,
    GeneralHeader,
  },
})
export default class WoerterRaetsel extends Vue {
  riddleModule: RiddleModule = getModule(RiddleModule, store);
  snackbarModule: SnackbarModule = getModule(SnackbarModule, this.$store);
  userModule: UserModule = getModule(UserModule, this.$store);

  get doneTutorial(): boolean {
    return this.riddleModule.hasDoneTutorial;
  }

  async beforeRouteLeave(to: any, from: any, next: () => void): Promise<void> {
    await (store as any).restored;
    this.userModule.stopActiveAudio();
    // try {
    //   await this.riddleModule.saveStatus(this.userModule.currentUser._id);
    //   this.snackbarModule.showMessage({
    //     message: 'Wörterrätsel gespeichert!',
    //     isSuccess: true,
    //   });
    // } catch (error) {
    //   this.snackbarModule.showMessage({
    //     message: 'Leider konnte ich nicht speichern.',
    //     isSuccess: false,
    //   });
    // }
    next();
  }
}
</script>
